export const EDITOR_ROUTE = {
  name: 'editor',
  route(): string[] {
    return ['/' + this.name];
  },
  DEFAULT: '',
  BRANCH: {
    name: 'branch/:domainId',
    route(domainId: string): string[] {
      return [...EDITOR_ROUTE.route(), this.name, domainId];
    }
  },
  BULK_EDITOR: {
    name: 'bulkeditor/:courseId',
    route(courseId: string): string[] {
      return [...EDITOR_ROUTE.route(), this.name, courseId];
    }
  },
  CONTENT_VIEW: {
    name: 'contentview',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  COURSE: {
    name: 'course/:courseid',
    route(courseId: string): string[] {
      return [...EDITOR_ROUTE.route(), 'course', courseId];
    },
    EDIT: {
      name: 'edit',
      route(courseId: string): string[] {
        return [...EDITOR_ROUTE.COURSE.route(courseId), this.name];
      }
    },
    FEATURED_CATEGORIES: {
      name: 'featuredcategories',
      route(courseId: string): string[] {
        return [...EDITOR_ROUTE.COURSE.route(courseId), this.name];
      }
    },
    FEATURED_CATEGORY: {
      name: 'featuredcategory/:featuredCategoryId/activities',
      route(courseId: string, featuredCategoryId: string): string[] {
        return [...EDITOR_ROUTE.COURSE.route(courseId), 'featuredcategory', featuredCategoryId, 'activities'];
      }
    }
  },
  COURSES: {
    name: 'courses',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  EXIT_TICKET_CATEGORIES: {
    name: 'exitticketcategories',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  EXPECTATION: {
    name: 'expectation/:expectationId',
    route(expectationId: string): string[] {
      return [...EDITOR_ROUTE.route(), 'expectation', expectationId];
    },
    TRANSLATOR: {
      name: 'translator',
      route(expectationId: string): string[] {
        return [...EDITOR_ROUTE.EXPECTATION.route(expectationId), 'translator'];
      }
    }
  },
  FEATURED_ACTIVITY: {
    name: 'featuredactivity/:featureCategoryId/:publicUnitId',
    route(featureCategoryId: string, publicUnitId: string): string[] {
      return [...EDITOR_ROUTE.route(), 'featuredactivity', featureCategoryId, publicUnitId];
    }
  },
  FEATURED_CATEGORIES: {
    name: 'featuredcategories',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  FEATURED_CATEGORY: {
    name: 'featuredcategory/:featuredCategoryId',
    route(featuredCategoryId: string): string[] {
      return [...EDITOR_ROUTE.route(), 'featuredcategory', featuredCategoryId];
    },
    PUBLIC_UNIT: {
      name: ':publicUnitId',
      route(featuredCategoryId: string, publicUnitId: string): string[] {
        return [...EDITOR_ROUTE.FEATURED_CATEGORY.route(featuredCategoryId), publicUnitId];
      }
    }
  },
  FLAGGED_QUESTIONS: {
    name: 'flaggedquestions',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  LEARNING_GOAL: {
    name: 'learninggoal/:goalId',
    route(goalId: string): string[] {
      return [...EDITOR_ROUTE.route(), 'learninggoal', goalId];
    },
    TRANSLATOR: {
      name: 'translator/:localeId',
      route(goalId: string, localeId: string): string[] {
        return [...EDITOR_ROUTE.LEARNING_GOAL.route(goalId), 'translator', localeId];
      },
      PREVIEW: {
        name: 'preview',
        route(goalId: string, localeId: string): string[] {
          return [...EDITOR_ROUTE.LEARNING_GOAL.TRANSLATOR.route(goalId, localeId), this.name];
        }
      }
    },
    TRANSLATOR_2: {
      name: 'translator2',
      route(goalId: string): string[] {
        return [...EDITOR_ROUTE.LEARNING_GOAL.route(goalId), this.name];
      }
    }
  },
  LOGICAL_ERROR: {
    name: 'logicalerror/:logicalErrorId',
    route(logicalErrorId: string): string[] {
      return [...EDITOR_ROUTE.route(), 'logicalerror', logicalErrorId];
    }
  },
  LOGICAL_ERRORS: {
    name: 'logicalerrors',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  QUESTION_BUCKET: {
    name: 'questionbucket/:questionBucketId',
    route(questionBucketId: string): string[] {
      return [...EDITOR_ROUTE.route(), 'questionbucket', questionBucketId];
    }
  },
  QUESTION_EDITOR_REPRTS: {
    name: 'questioneditorreports',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  REVIEW_MATH_ML: {
    name: 'reviewmathmlconversions',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  SETTINGS: {
    name: 'settings',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  },
  CALENDARS: {
    name: 'calendars',
    route(): string[] {
      return [...EDITOR_ROUTE.route(), this.name];
    }
  }
};
